import { LoadingOutlined } from "@ant-design/icons";
import { useAuth } from "context/AuthContextProvider";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PATHS from "shared/constants/paths";

const LogoutScreen = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    signOut();
    // `replace` so this route never lingers in history: the menu (and the
    // axios force-logout) push /logout, and a later Back onto that entry would
    // re-run this effect and sign the admin out again mid-session.
    navigate(PATHS.LOGIN, { replace: true });
    // eslint-disable-next-line
  }, []);

  return <LoadingOutlined />;
};

export default LogoutScreen;
